module.exports = __webpack_public_path__ + "static/img/High Resilience Silicone Rubber.cbb7628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/High Resilience Silicone Rubber.jpg
// module id = 400A
// module chunks = 1